import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/logo_leanpath.png'


const _hoisted_1 = { class: "centered-container" }
const _hoisted_2 = { class: "language-selector" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "actions login-button-area" }
const _hoisted_5 = { class: "links" }
const _hoisted_6 = {
  key: 0,
  class: "accessing-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_md_input = _resolveComponent("md-input")!
  const _component_md_field = _resolveComponent("md-field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_md_snackbar = _resolveComponent("md-snackbar")!
  const _component_md_progress_spinner = _resolveComponent("md-progress-spinner")!
  const _component_md_content = _resolveComponent("md-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_notifications),
    _createVNode(_component_md_content, { class: "md-elevation-3" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.selectedLang) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeLang && _ctx.changeLang(...args)))
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("option", { value: "ja" }, "日本語", -1),
            _createElementVNode("option", { value: "en" }, "English", -1)
          ]), 544), [
            [_vModelSelect, _ctx.state.selectedLang]
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "title-image"
              })
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_md_field, { class: "email" }, {
            default: _withCtx(() => [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('メールアドレス')), 1),
              _createVNode(_component_md_input, {
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.email) = $event)),
                "data-testid": `login_email_address`,
                autofocus: ""
              }, null, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_md_field, { "md-has-password": "" }, {
            default: _withCtx(() => [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('パスワード')), 1),
              _createVNode(_component_md_input, {
                modelValue: _ctx.state.password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.password) = $event)),
                "data-testid": `login_password`,
                type: "password",
                autofocus: "",
                onKeydown: _withKeys(_ctx.doLogin, ["enter"])
              }, null, 8, ["modelValue", "onKeydown"])
            ], undefined, true),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            "data-testid": `login_button`,
            class: "",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)))
          }, _toDisplayString(_ctx.$t('ログイン')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _createVNode(_component_router_link, {
              "data-testid": `forgot_password_link`,
              class: "forgetpass",
              to: "/forgetpass"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('パスワードをお忘れの方')), 1)
              ], undefined, true),
              _: 1
            })
          ]),
          _createElementVNode("span", {
            style: _normalizeStyle(_ctx.styles.verifyCode)
          }, [
            _createVNode(_component_router_link, {
              "data-testid": `input_verification_code_link`,
              class: "verifycode",
              to: "/verifycode"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('検証コードはこちら')), 1)
              ], undefined, true),
              _: 1
            })
          ], 4)
        ]),
        _createVNode(_component_md_snackbar, {
          "md-active": _ctx.state.showSnackbar,
          "onUpdate:mdActive": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.showSnackbar) = $event)),
          "md-position": "center",
          "md-duration": 2000,
          "md-persistent": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.state.snackMessage), 1)
          ], undefined, true),
          _: 1
        }, 8, ["md-active"]),
        (_ctx.state.accessing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_md_progress_spinner, {
                "md-mode": "indeterminate",
                "md-stroke": 2
              })
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1,
      __: [7]
    })
  ]))
}